import React, { createContext, useContext, useEffect, useState } from 'react';
import { io } from 'socket.io-client';
import { useAuth } from './AuthContext';

const SocketContext = createContext();

export const useSocket = () => {
  const context = useContext(SocketContext);
  return context;
};

const getSocketUrl = () => {
  // Use the same centralized API URL as api.js
  const apiUrl = 'https://nextstep.mayurr.in/api';
  try {
    const url = new URL(apiUrl);
    return `${url.protocol}//${url.hostname}${url.port ? ':' + url.port : ''}`;
  } catch {
    return 'https://nextstep.mayurr.in';
  }
};

export const SocketProvider = ({ children }) => {
  const { user, isAuthenticated } = useAuth();
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    if (!isAuthenticated || !user) {
      if (socket) {
        socket.disconnect();
        setSocket(null);
      }
      return;
    }

    const url = getSocketUrl();
    const s = io(url, { transports: ['websocket', 'polling'] });
    setSocket(s);

    const role = (user.role || '').toLowerCase();
    if (role === 'engineer') {
      s.emit('join-engineer', user.id);
    } else if (role === 'admin') {
      s.emit('join-admin');
    } else if (role === 'user' || role === 'customer') {
      s.emit('join-user', user.id);
    }

    return () => {
      s.disconnect();
      setSocket(null);
    };
  }, [isAuthenticated, user?.id, user?.role]);

  return (
    <SocketContext.Provider value={socket}>
      {children}
    </SocketContext.Provider>
  );
};
